// BIOGRAPHY SUBPAGE COMPONENENT

import React, { useContext } from "react";
import MetaTags from "react-meta-tags";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PageTitle } from "./helper/PageTitle";
import { Scroll } from "./helper/Scroll";

const BiographyWrapper = styled.article`
  display: flex;
  align-items: start;
  justify-content: space-evenly;
  ${variables.DimensionsView};
  padding: 5rem 2rem;
  background-color: ${variables.BACKGROUND_GRAY};

  @media (max-width: 1000px) {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    padding: 5rem 0;
    height: auto;
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    justify-content: space-between;
  }
`;

const BiographyParagraph = styled.p`
  display: flex;
  align-items: start;
  justify-content: center;
  max-width: 40%;
  height: auto;
  color: ${variables.BACKGROUND_GRAY};
  animation: ${variables.ChangeColor} 0.5s 1.5s linear forwards;

  @media (max-width: 1000px) {
    max-width: 100%;
    height: auto;
    padding: 2rem;
  }

  @media (max-width: 850px) {
    font-size: ${variables.MOBILE_FONT};
  }
`;

const BiographyImage = styled(LazyLoadImage)`
  ${variables.Flex};
  max-height: 80vh;
  color: ${variables.WHITE};
  opacity: 0;
  animation: ${variables.ChangeOpacity} 0.5s 1.5s linear forwards;

  @media (max-width: 500px), (max-width: 850px) and (orientation: landscape) {
    max-width: 100%;
    height: auto;
    padding: 2rem;
  }
`;

export const Biography = () => {
  const usedLanguage = useContext(LanguageContext);

  const { biographyHeader, biographyParagraph, biographyImage } =
    usedLanguage.language.biography;

  Scroll();

  return (
    <main>
      <MetaTags>
        <title>{biographyHeader} | Structuralist</title>
        <meta name="description" content={biographyParagraph} />
        <meta
          name="keywords"
          content={`"Structuralist", "Michał Król", ${biographyHeader}`}
        />
      </MetaTags>
      <PageTitle
        text={biographyHeader}
        backgroundColor={variables.BACKGROUND_GRAY} //Styled Components props
      />
      <BiographyWrapper>
        <BiographyParagraph>{biographyParagraph}</BiographyParagraph>
        <BiographyImage
          src={biographyImage}
          alt={`${biographyHeader} - Michał Król - Structuralist`}
        />
      </BiographyWrapper>
    </main>
  );
};
